import Cookies from 'js-cookie';

import { CurrencyIsoTypeEnum } from '../common/pokCore/validation/enums';
import { GetCurrencyDto } from '../common/pokCore/autogenerated/pokApiClient';

export class Currency {
  currencyCode?: string;
  countryCode?: string;
}

export const getMainCurrencySymbol = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return getMainCurrency()?.currencyCode as any;
};

export const getStoredMainCurrency = (): GetCurrencyDto | undefined => {
  const currencyItem = sessionStorage.getItem('pok-currency');
  if (currencyItem) {
    return JSON.parse(currencyItem);
  }
  const companyItem = Cookies.get('company-object');
  if (!companyItem || companyItem === 'undefined') {
    return undefined;
  }
  const mainCurrency = JSON.parse(companyItem)?.mainCurrency;
  if (!mainCurrency) {
    return undefined;
  }
  sessionStorage.setItem('pok-currency', JSON.stringify(mainCurrency));
  return mainCurrency;
};

export const getMainCurrency = (): Currency => {
  const currency = getStoredMainCurrency();
  return {
    countryCode: currency?.countryCode,
    currencyCode: currency?.currencyCode,
  };
};

export const isMainCurrencyPLN = () => {
  return getMainCurrency()?.currencyCode === CurrencyIsoTypeEnum.PLN;
};

export const getCurrencyOptions = () => {
  const curr = getMainCurrencySymbol();
  if (curr === CurrencyIsoTypeEnum.PLN) {
    return Object.entries(CurrencyIsoTypeEnum).map(([key, value]) => ({
      value: key as CurrencyIsoTypeEnum,
      label: value,
    }));
  } else {
    return [{ value: curr, label: curr }];
  }
};

export const getCurrencySymbol = (currencyCode: string, locale: string) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencyDisplay: 'narrowSymbol',
  });
  const parts = formatter.formatToParts(0);
  const currencySymbol =
    parts.find(part => part.type === 'currency')?.value ?? '';

  return currencySymbol;
};

export const isCurrencySymbolBeforeAmount = (
  currencyCode: string,
  locale: string,
) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  });
  const parts = formatter.formatToParts(1);
  const currencyIndex = parts.findIndex(part => part.type === 'currency');
  const integerIndex = parts.findIndex(part => part.type === 'integer');
  return currencyIndex < integerIndex;
};

export const getThousandSeparator = (locale: string) => {
  const formatter = new Intl.NumberFormat(locale);
  const parts = formatter.formatToParts(1000);
  const thousandSeparator =
    parts.find(part => part.type === 'group')?.value ?? ' ';
  return thousandSeparator;
};

export const getDecimalSeparator = (locale: string) => {
  const formatter = new Intl.NumberFormat(locale);
  const parts = formatter.formatToParts(1.1);
  const decimalSeparator =
    parts.find(part => part.type === 'decimal')?.value ?? ',';
  return decimalSeparator;
};

export default {
  getCurrencySymbol,
  isCurrencySymbolBeforeAmount,
  getThousandSeparator,
  getDecimalSeparator,
  getCurrencyOptions,
};
